module.exports = __webpack_public_path__ + "static/media/btn-image-2.aa549cb8.png";